<template lang="pug">
    div(
        class="full-width"
        :key="id"
    )
        v-layout(wrap ma-2)
            v-flex#top-bar(xs12)
                v-layout(justify-space-between)
                    v-flex.text-xs-left.mr-2(shrink)
                        img(:src="icon" height=30)
                    div(class="date")
                        span {{properDate}}  
                        span {{time}} 
                        br
            v-flex#status-body.mt-3.mb-6(xs12)
                v-layout(column justify-start class="field")
                    span(class="summary") {{fullName}}'s application for ${{properAmount}} is {{statusToShow}}
                    v-layout(class="application-details")
                        span Application ID: {{providerId}}
            v-flex#buttons-bar(xs-12)
                v-layout(row justify-end wrap)
                    v-btn.mr-0(
                        v-if="shouldHaveButton"
                        flat 
                        outline 
                        color="secondary"  
                        @click = "storeAndRedirect"
                        ) See More       
        v-divider            
</template>

<script>
import {format} from "date-fns"
import {mapActions} from "vuex"
import {numberWithCommas} from "@/helpers/parsingFunctions"
import envVars from '@/env_vars.js'
    export default {
        name: "prequal-application-list-tile",
        props: {
            id: String,
            providerId: String,
            icon: String,
            submitDate: String,
            firstName: String,
            lastName: String,
            providerStatus: String,
            requestAmount: Number,
            status: String
        },
        data(){
            return {
                environment: envVars.environment,
                numberWithCommas
            }
        },
        computed:{
            properDate(){
                const date = new Date(this.submitDate)
                return format(date, 'MM/dd/yyyy')
            },
            properAmount(){
                return this.numberWithCommas(this.requestAmount)
            },
            time(){
                const date = new Date(this.submitDate)
                const options = {
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: true
                }
                return date.toLocaleString('en-US', options)
            },
            fullName(){
                return `${this.firstName.toUpperCase()} ${this.lastName.toUpperCase()}`
            },
            statusToShow(){
                if(this.status === "StatusCheckOngoing" || this.status === "StatusCheckTimedOut" || this.status ==="StatusCheckFailed" || this.status === "FailedToRetrieveOffers"){
                    return "In Progress"
                } else {
                    return this.providerStatus
                }
            },
            shouldHaveButton(){
                return this.providerStatus === "Authorized" || this.status === "StatusCheckTimedOut" || this.status === "StatusCheckOngoing" || this.status === "StatusCheckFailed" || this.status === "FailedToRetrieveOffers"
            }
        },
        methods: {
            ...mapActions(['savePreQualId', 'loanApplicationClear', 'hardSSNReset']),
            storeAndRedirect(){
                this.savePreQualId(this.id)
                this.loanApplicationClear()
                //Clear SSN from mock data if not in production
                if(
                this.environment === 'development'
                || this.environment === 'staging'
                || this.environment === 'demo'
                ) {
                    this.hardSSNReset('')
                }
                this.$router.push({
                    path: '/prequal-results'
                })
                
            }
        },
        mounted(){
            this.savePreQualId(null)
        }
    }
</script>

<style scoped>
.date{
    display: flex;
    flex-direction: column;
    align-items: baseline;
    color: #9e9e9e;
    font: "Avenir";
    font-weight: 400;
}
.date span{
    align-self: end;
}
.summary{
    font-size: 20px;
    font-weight:bold;
    margin-bottom: 10px
}
.field{
    text-align: left;
    padding: 8px
}
.application-details{
    display: flex;
    flex-direction: column;
    padding: 10px 0px;
    background-color:#ECEFF1;
    word-wrap: break-word;
    color: rgba(0,0,0,0.5)
}
.application-details span{
    padding-top: 5px;
    padding-left: 7px
}
</style>